import React, { Component } from "react";

class Iframe extends Component {
    render() {
      return(         
        <div>          
          <iframe id={this.props.id} src={this.props.src} style={this.props.style} height={this.props.height} width={this.props.width} frameborder="0"/>         
        </div>
      )
    }
}
export default Iframe;